/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponseVM } from '../models/BooleanResponseVM';
import type { CommunicationVM } from '../models/CommunicationVM';
import type { CommunicationVMIEnumerableResponseVM } from '../models/CommunicationVMIEnumerableResponseVM';
import type { CommunicationVMResponseVM } from '../models/CommunicationVMResponseVM';
import type { ContactListResponseVM } from '../models/ContactListResponseVM';
import type { EmailMessageResponseResponseVM } from '../models/EmailMessageResponseResponseVM';
import type { EmailMessageResponseVM } from '../models/EmailMessageResponseVM';
import type { MessageChannelVMIEnumerableResponseVM } from '../models/MessageChannelVMIEnumerableResponseVM';
import type { MessageVM } from '../models/MessageVM';
import type { MessageVMIEnumerableResponseVM } from '../models/MessageVMIEnumerableResponseVM';
import type { MessageVMResponseVM } from '../models/MessageVMResponseVM';
import type { MobileDeviceInfoVM } from '../models/MobileDeviceInfoVM';
import type { MobileDeviceInfoVMResponseVM } from '../models/MobileDeviceInfoVMResponseVM';
import type { SaveAccessInfoRequest } from '../models/SaveAccessInfoRequest';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { StringStringDictionaryResponseVM } from '../models/StringStringDictionaryResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommunicationService {
    /**
     * @param requestBody
     * @returns CommunicationVMResponseVM Success
     * @throws ApiError
     */
    public static postApiCommunication(
        requestBody?: CommunicationVM,
    ): CancelablePromise<CommunicationVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Communication',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CommunicationVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiCommunicationInbox(
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CommunicationVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Communication/inbox',
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns CommunicationVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiCommunicationSent(
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<CommunicationVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Communication/sent',
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param communicationId
     * @returns CommunicationVMResponseVM Success
     * @throws ApiError
     */
    public static getApiCommunication(
        communicationId: number,
    ): CancelablePromise<CommunicationVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Communication/{communicationId}',
            path: {
                'communicationId': communicationId,
            },
        });
    }
    /**
     * @param communicationId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiCommunication(
        communicationId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Communication/{communicationId}',
            path: {
                'communicationId': communicationId,
            },
        });
    }
    /**
     * @param to
     * @param subject
     * @param body
     * @param emailId
     * @param threadId
     * @param formData
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailSendEmailMessage(
        to?: string,
        subject?: string,
        body?: string,
        emailId?: string,
        threadId?: string,
        formData?: {
            Attachments?: Array<Blob>;
        },
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/send-email-message',
            query: {
                'To': to,
                'Subject': subject,
                'Body': body,
                'EmailId': emailId,
                'ThreadId': threadId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param to
     * @param subject
     * @param body
     * @param emailId
     * @param threadId
     * @param formData
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailReplyEmailThread(
        to?: string,
        subject?: string,
        body?: string,
        emailId?: string,
        threadId?: string,
        formData?: {
            Attachments?: Array<Blob>;
        },
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/reply-email-thread',
            query: {
                'To': to,
                'Subject': subject,
                'Body': body,
                'EmailId': emailId,
                'ThreadId': threadId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param nextPageToken
     * @param maxResults
     * @param query
     * @returns EmailMessageResponseResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailListEmailMessages(
        nextPageToken?: string,
        maxResults: number = 5,
        query: string = 'label:inbox',
    ): CancelablePromise<EmailMessageResponseResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/list-email-messages',
            query: {
                'nextPageToken': nextPageToken,
                'maxResults': maxResults,
                'query': query,
            },
        });
    }
    /**
     * @param nextPageToken
     * @param maxResults
     * @param query
     * @returns EmailMessageResponseResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailListEmailThreads(
        nextPageToken?: string,
        maxResults: number = 5,
        query: string = 'label:inbox',
    ): CancelablePromise<EmailMessageResponseResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/list-email-threads',
            query: {
                'nextPageToken': nextPageToken,
                'maxResults': maxResults,
                'query': query,
            },
        });
    }
    /**
     * @param emailId
     * @returns EmailMessageResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailEmailMessage(
        emailId?: string,
    ): CancelablePromise<EmailMessageResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/email-message',
            query: {
                'emailId': emailId,
            },
        });
    }
    /**
     * @param threadId
     * @returns EmailMessageResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailEmailThread(
        threadId?: string,
    ): CancelablePromise<EmailMessageResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/email-thread',
            query: {
                'threadId': threadId,
            },
        });
    }
    /**
     * @returns StringStringDictionaryResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailShowTokens(): CancelablePromise<StringStringDictionaryResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/show-tokens',
        });
    }
    /**
     * @returns ContactListResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailGetContacts(): CancelablePromise<ContactListResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/get-contacts',
        });
    }
    /**
     * @param query
     * @returns ContactListResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailSearchContacts(
        query?: string,
    ): CancelablePromise<ContactListResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/search-contacts',
            query: {
                'query': query,
            },
        });
    }
    /**
     * @param requestBody
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailSaveRequestToken(
        requestBody?: SaveAccessInfoRequest,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/save-request-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static getApiGmailHasRefreshToken(): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Gmail/has-refresh-token',
        });
    }
    /**
     * @param emailId
     * @param isImportant
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailToggleMessageImportance(
        emailId?: string,
        isImportant?: boolean,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/toggle-message-importance',
            query: {
                'emailId': emailId,
                'isImportant': isImportant,
            },
        });
    }
    /**
     * @param emailId
     * @param isStarred
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailToggleMessageStarred(
        emailId?: string,
        isStarred?: boolean,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/toggle-message-starred',
            query: {
                'emailId': emailId,
                'isStarred': isStarred,
            },
        });
    }
    /**
     * @param threadId
     * @param isImportant
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailToggleThreadImportance(
        threadId?: string,
        isImportant?: boolean,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/toggle-thread-importance',
            query: {
                'threadId': threadId,
                'isImportant': isImportant,
            },
        });
    }
    /**
     * @param threadId
     * @param isStarred
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailToggleThreadStarred(
        threadId?: string,
        isStarred?: boolean,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/toggle-thread-starred',
            query: {
                'threadId': threadId,
                'isStarred': isStarred,
            },
        });
    }
    /**
     * @param emailId
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static deleteApiGmailDeleteEmailMessage(
        emailId?: string,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Gmail/delete-email-message',
            query: {
                'emailId': emailId,
            },
        });
    }
    /**
     * @param threadId
     * @returns BooleanResponseVM Success
     * @throws ApiError
     */
    public static deleteApiGmailDeleteEmailThread(
        threadId?: string,
    ): CancelablePromise<BooleanResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Gmail/delete-email-thread',
            query: {
                'threadId': threadId,
            },
        });
    }
    /**
     * @param to
     * @param subject
     * @param body
     * @param emailId
     * @param threadId
     * @param formData
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailForwardEmailMessage(
        to?: string,
        subject?: string,
        body?: string,
        emailId?: string,
        threadId?: string,
        formData?: {
            Attachments?: Array<Blob>;
        },
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/forward-email-message',
            query: {
                'To': to,
                'Subject': subject,
                'Body': body,
                'EmailId': emailId,
                'ThreadId': threadId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param to
     * @param subject
     * @param body
     * @param emailId
     * @param threadId
     * @param formData
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailForwardEmailThread(
        to?: string,
        subject?: string,
        body?: string,
        emailId?: string,
        threadId?: string,
        formData?: {
            Attachments?: Array<Blob>;
        },
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/forward-email-thread',
            query: {
                'To': to,
                'Subject': subject,
                'Body': body,
                'EmailId': emailId,
                'ThreadId': threadId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param to
     * @param subject
     * @param body
     * @param emailId
     * @param threadId
     * @param formData
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static postApiGmailReplyEmailMessage(
        to?: string,
        subject?: string,
        body?: string,
        emailId?: string,
        threadId?: string,
        formData?: {
            Attachments?: Array<Blob>;
        },
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Gmail/reply-email-message',
            query: {
                'To': to,
                'Subject': subject,
                'Body': body,
                'EmailId': emailId,
                'ThreadId': threadId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns MessageChannelVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiMessageOrganizationlistMessagechannels(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<MessageChannelVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Message/{organizationId}/organizationlist/messagechannels',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns MessageVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiMessageTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<MessageVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Message/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns MessageVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiMessageContractorlist(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<MessageVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Message/{contractorId}/contractorlist',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param messageId
     * @returns MessageVMResponseVM Success
     * @throws ApiError
     */
    public static getApiMessage(
        messageId: number,
    ): CancelablePromise<MessageVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Message/{messageId}',
            path: {
                'messageId': messageId,
            },
        });
    }
    /**
     * @param messageId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiMessage(
        messageId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Message/{messageId}',
            path: {
                'messageId': messageId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns MessageVMResponseVM Success
     * @throws ApiError
     */
    public static postApiMessage(
        requestBody?: MessageVM,
    ): CancelablePromise<MessageVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns MessageVMResponseVM Success
     * @throws ApiError
     */
    public static putApiMessage(
        requestBody?: MessageVM,
    ): CancelablePromise<MessageVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns MobileDeviceInfoVMResponseVM Success
     * @throws ApiError
     */
    public static putApiMessageDeviceinfo(
        requestBody?: MobileDeviceInfoVM,
    ): CancelablePromise<MobileDeviceInfoVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Message/deviceinfo',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
